import * as React from "react";
import type { SVGProps } from "react";

interface Minutes10Props extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Minutes10 = ({ cancelled = false, ...props }: Minutes10Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.5 1)">
        <ellipse cx={9.75} cy={12.93} fill="#FFF" rx={8.09} ry={8.14} />
        <path
          fill="#000"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M10.99-.38A1.32 1.32 0 0 1 12.3.8c0 .47-.13.82-.35 1.07-.24.28-.58.44-.96.44l-.38.52a9.88 9.88 0 0 1 8.77 9.74 9.88 9.88 0 0 1-9.88 9.8 9.88 9.88 0 0 1-9.88-9.8A9.88 9.88 0 0 1 8.4 2.83V2.3c-.74 0-1.07-.15-1.31-.39a1.37 1.37 0 0 1 0-1.9c.23-.24.56-.4.93-.4H11ZM9.5 4.97a7.67 7.67 0 0 0-7.66 7.6 7.67 7.67 0 0 0 13.08 5.38 7.55 7.55 0 0 0 0-10.75A7.67 7.67 0 0 0 9.5 4.97Z"
        />
      </g>
      <path
        fill="#FF1212"
        fillRule="nonzero"
        d="M9.15 18.1c-.52 0-.78-.29-.78-.86v-6.26l-.79.53c-.49.32-.86.26-1.13-.18-.14-.22-.18-.43-.12-.62.05-.2.2-.36.43-.5l1.48-.92a1.76 1.76 0 0 1 1.07-.3c.4 0 .61.28.61.86v7.4c0 .56-.26.85-.77.85m5.57.13c-.71 0-1.27-.18-1.67-.53-.4-.36-.67-.88-.83-1.58a11.7 11.7 0 0 1-.23-2.57c0-1.03.07-1.9.23-2.59s.43-1.21.83-1.57.96-.53 1.67-.53c.7 0 1.26.17 1.65.53s.66.88.82 1.57c.16.7.24 1.56.24 2.59 0 1.02-.08 1.88-.24 2.57-.16.7-.43 1.22-.82 1.58-.4.35-.94.53-1.65.53m0-1.48c.3 0 .52-.1.7-.28.16-.19.28-.51.36-.98.07-.46.1-1.1.1-1.94 0-.83-.03-1.48-.1-1.95-.08-.47-.2-.8-.37-.98a.9.9 0 0 0-.7-.28c-.29 0-.52.1-.7.28-.17.18-.3.51-.37.98s-.1 1.12-.1 1.95.03 1.48.1 1.94c.08.47.2.8.38.98.17.18.4.28.7.28"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Minutes10;
